import "./basic.css"

export default function MainLayout({children}) {
    return (<>

        <main>
        {children}
        </main>

        {/* <footer>
            Katy ist die coolste hehe
        </footer> */}
    </>);
}